import {
  redirectToPersonalDetails,
  redirectToBusinessDetailsApp,
  redirectToSubmissionPage,
  redirectOnExit
} from '../../utils/redirectUtils';
import {
  NAVIGATE_TO_CD,
  INITIAL_QUESTIONS_TMSP,
  CASE_ID,
  NAVIGATE_TO_BD_REVIEW,
  NAVIGATE_TO_CD_REVIEW,
  NAVIGATE_TO_BD,
  BUSINESS_TYPE,
  ACCESS_TOKEN,
  CUSTOMER_UUID,
  BDD_ABOUT_YOUR_BUSINESS,
  ROUTE_USERNAME_PASSWORD_PAGE,
  BDD_REVIEW_PAGE,
  ROUTE_ACCOUNT_DETAILS_PAGE,
  ROUTE_REVIEW_PAGE,
  BUSINESS_CURRENT_ACCOUNT,
  CASE_TYPE_EXISTING,
  CASE_TYPE_NTB,
  NAVIGATE_TO_SUBMISSION_PAGE,
  OFFER_CASE_ID,
  BUSINESS_ACCOUNT_OPENING,
  SAVE_AND_RESUME_CAPTURE,
  CASE_SUBTYPE,
  SOURCE_ID,
  INITIAL_INFO,
  LINK_CODE_KEY,
  NAVIGATION_BACK,
  PRODUCT_NAME,
  NAVIGATE_TO_EXIT,
  APPLICANT_FLOW,
  LINK_CODE_RESUME_FLOW
} from '../../utils/constants';
import {
  getQueryStringValueByName,
  getCaseSubType,
  validateRouteToRedirect,
  isBackNavigation
} from '../../utils';
import { getBusinessType } from '../dataCapture/payloads';
import { selectors as caseSelector } from '../../infrastructure/cases';

export const BD_REVIEW = 'RV';
const SOLE_TRADER = 'sole trader';

const redirectActionMiddleware = store => next => action => {
  const result = next(action);
  if (action.redirect) {
    const state = store.getState();
    const configObj = state.config;
    const dataCapture = state.dataCapture;
    let businessType = dataCapture.get(INITIAL_INFO);
    businessType = businessType ? businessType.get('businessTypeField') : '';
    const access_token = configObj.get(ACCESS_TOKEN);
    const customer_uuid = configObj.get(CUSTOMER_UUID);
    const bank_id = configObj.get('bank_id');
    const brand_id = configObj.get('brand_id');
    let offer = configObj.get(PRODUCT_NAME);
    offer = offer ? decodeURIComponent(offer) : BUSINESS_CURRENT_ACCOUNT;
    const timestamp =
      dataCapture.get(INITIAL_QUESTIONS_TMSP) || configObj.get(INITIAL_QUESTIONS_TMSP);
    const linkCode = configObj.get(LINK_CODE_KEY) || caseSelector.getJointLinkCode(state);
    const customerUrl = configObj.get('customerDetailsUrl');
    const businessDetailsUrl = configObj.get('businessDetailsUrl');
    if (action.redirect.to && action.redirect.to.length > 0) {
      switch (action.redirect.to) {
        case NAVIGATE_TO_CD:
          const caseType = getCaseType(configObj, access_token, action.redirect.navigation);
          businessType = businessType || getBusinessType(caseType, state);
          const show = getScreensByBusinessType(businessType);
          const sourceId = configObj.get(SOURCE_ID);
          redirectToPersonalDetails(
            customerUrl,
            access_token,
            bank_id,
            brand_id,
            show,
            businessType,
            customer_uuid,
            ROUTE_USERNAME_PASSWORD_PAGE,
            offer,
            caseType,
            timestamp,
            getCaseID(configObj),
            NAVIGATE_TO_CD,
            action.redirect.navigation,
            sourceId,
            linkCode
          );
          break;
        case NAVIGATE_TO_CD_REVIEW:
          const business_type_review = getQueryStringValueByName(BUSINESS_TYPE) || businessType;
          const show_review = getScreensByBusinessType(business_type_review);
          const primaryApplicantFlow = configObj.get(APPLICANT_FLOW);
          redirectToPersonalDetails(
            customerUrl,
            access_token,
            bank_id,
            brand_id,
            show_review,
            business_type_review,
            customer_uuid || caseSelector.getPersonalCustomerId(state),
            BDD_REVIEW_PAGE,
            offer,
            getCaseSubType(state),
            '',
            getCaseID(configObj) || action.redirect.caseId,
            NAVIGATE_TO_CD_REVIEW,
            '',
            '',
            linkCode,
            primaryApplicantFlow,
            action.redirect.linkCodeResume
          );
          break;
        case NAVIGATE_TO_BD:
          const businesstype = businessType || getQueryStringValueByName(BUSINESS_TYPE);
          redirectToBusinessDetailsApp(
            businessDetailsUrl,
            getCaseID(dataCapture),
            access_token,
            getCaseSubType(state),
            bank_id,
            brand_id,
            businesstype,
            customer_uuid,
            offer,
            BDD_ABOUT_YOUR_BUSINESS,
            ROUTE_ACCOUNT_DETAILS_PAGE,
            getBDDScreensByBusinessType(businesstype),
            action.redirect.navigation,
            timestamp,
            '',
            getQueryStringValueByName(APPLICANT_FLOW)
          );
          break;
        case NAVIGATE_TO_BD_REVIEW:
          const businesstypeReview = getQueryStringValueByName(BUSINESS_TYPE);
          redirectToBusinessDetailsApp(
            businessDetailsUrl,
            getCaseID(configObj),
            access_token,
            getCaseSubType(state),
            bank_id,
            brand_id,
            businesstypeReview,
            customer_uuid,
            offer,
            BDD_REVIEW_PAGE,
            ROUTE_REVIEW_PAGE,
            BD_REVIEW,
            action.redirect.navigation,
            '',
            getQueryStringValueByName(LINK_CODE_KEY),
            getQueryStringValueByName(APPLICANT_FLOW),
            getQueryStringValueByName(LINK_CODE_RESUME_FLOW)
          );
          break;
        case NAVIGATE_TO_SUBMISSION_PAGE:
          redirectToSubmissionPage(
            getSubmisionUrl(configObj, bank_id),
            configObj.get(OFFER_CASE_ID),
            access_token
          );
          break;
        case NAVIGATE_TO_EXIT:
          redirectOnExit(bank_id);
          break;
        default:
          break;
      }
    }
  }
  return result;
};

const getCaseType = (stateObject, access_token, navigation) => {
  if (
    validateRouteToRedirect(SAVE_AND_RESUME_CAPTURE) ||
    navigation === NAVIGATION_BACK ||
    isBackNavigation()
  ) {
    return stateObject.get(CASE_SUBTYPE);
  }
  return access_token ? CASE_TYPE_EXISTING : CASE_TYPE_NTB;
};

const getCaseID = stateObject => {
  const case_id = stateObject.get(CASE_ID) || stateObject.get(OFFER_CASE_ID);
  return case_id ? case_id : '';
};

const getSubmisionUrl = (configObj, bank_id) => {
  const urls = configObj.get('applicationURIs');
  return urls ? urls.toJS()[BUSINESS_ACCOUNT_OPENING][bank_id.toUpperCase()] : '';
};

const getScreensByBusinessType = type =>
  type.toLowerCase() !== SOLE_TRADER ? 'PD,NL,AD,CD' : 'PD,NL,AD,TF,CD';
export const getBDDScreensByBusinessType = type =>
  type && type.toLowerCase() !== SOLE_TRADER ? 'BD,BF,TF,CD,GD' : 'BD,BF,CD,GD';

export default redirectActionMiddleware;
